// @ts-nocheck
document.addEventListener('DOMContentLoaded', () => {
  const customSectionSelector = '.shopify-section-group-footer-group';
  const modalParamName = 'trigger-ex-modal';
  const urlParams = new URLSearchParams(window.location.search);
  const modalParam = urlParams.get(modalParamName);
  const explorePlusModalActions = document.querySelectorAll('.explore-plus-modal-action.open-modal');
  const form = document.querySelector('.formful__dialog form');
  const formWrapper = document.querySelector(customSectionSelector + ' .formful__dialog .formful__wrapper');
  const explorePlusModalTemplate = document.querySelector('#explore-plus-member-modal');
  const template = explorePlusModalTemplate?.innerHTML;
  const formDialog = document.querySelector(customSectionSelector + ' .formful__dialog');
  const thankYou = formWrapper?.querySelector('.formful__thanks-message');
  const appProxyUrl = '/apps/loyalty/coupons';

  const copyIconSvg = `
    <svg class="icon-copy" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="#322F2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.33334 10H2.66668C2.31305 10 1.97392 9.85956 1.72387 9.60952C1.47382 9.35947 1.33334 9.02033 1.33334 8.66671V2.66671C1.33334 2.31309 1.47382 1.97395 1.72387 1.7239C1.97392 1.47385 2.31305 1.33337 2.66668 1.33337H8.66668C9.0203 1.33337 9.35944 1.47385 9.60949 1.7239C9.85953 1.97395 10 2.31309 10 2.66671V3.33337" stroke="#322F2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const checkIconSvg = `
    <svg class="icon-check" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  if (thankYou && template) {
    thankYou.innerHTML = template;
  }

  // Update formful overlay login link with Shopify storefront route
  const updateFormfulLoginLink = () => {
    const storefrontLoginDataElement = document.getElementById('storefront-login-data');
    const storefrontLoginUrl = storefrontLoginDataElement?.dataset.storefrontLoginUrl;

    if (!storefrontLoginUrl) return;

    const overlayLoginLink = document.querySelector(
      '.formful__dialog .formful__overlay a[href="#storefront_login_url"]',
    );

    if (overlayLoginLink && !overlayLoginLink.dataset.listenerAttached) {
      overlayLoginLink.setAttribute('href', storefrontLoginUrl);
      overlayLoginLink.classList.add('button');

      // Set flag in sessionStorage to trigger modal after login redirect
      overlayLoginLink.addEventListener('click', () => {
        sessionStorage.setItem('openExplorePlusModal', 'true');
      });

      overlayLoginLink.dataset.listenerAttached = 'true';
    }
  };

  const openExplorePlusModal = () => {
    formDialog.showModal();

    // Update login link when modal opens
    updateFormfulLoginLink();

    // Lock body scroll when modal opens — prevent background scrolling
    document.body.style.overflow = 'hidden';

    // Small delay to ensure modal is rendered before fetching coupons
    setTimeout(() => {
      fetchCustomerCoupons();
      handleOverlayFormControls();
    }, 100);
  };

  const updateModal = () => {
    form.style.display = 'none';
    thankYou.classList.remove('formful__hide');
  };

  // Function to disable form controls when overlay is present
  const handleOverlayFormControls = () => {
    const overlay = formDialog?.querySelector('.formful__overlay');

    if (overlay) {
      // Find all text inputs, checkboxes, and buttons within the form
      const formControls = form?.querySelectorAll('input[type="text"], input[type="checkbox"], button[type="submit"]');

      formControls?.forEach((control) => {
        control.setAttribute('tabindex', '-1');
      });
    }
  };

  // Add event to dynamically inserted continue button
  formDialog?.addEventListener('click', (e) => {
    if (e.target.closest('.explore-plus-continue')) {
      formDialog.close();
    }
  });

  if (explorePlusModalTemplate?.content.querySelector('[data-is-subscribed="true"]')) {
    updateModal();
  }

  // Helper function to escape HTML
  const escapeHtml = (text) => {
    if (text == null) return '-';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString(document.documentElement.lang, { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (e) {
      return dateString;
    }
  };

  // Helper function to translate level codes to display names
  const translateLevel = (levelCode) => {
    if (!levelCode) return 'N/A';

    // Get translations from template dataset
    const levelTranslations = {
      LEVEL1: explorePlusModalTemplate?.dataset.levelLevel1 || 'Novice',
      LEVEL2: explorePlusModalTemplate?.dataset.levelLevel2 || 'Enthusiast',
      LEVEL3: explorePlusModalTemplate?.dataset.levelLevel3 || 'Expert',
      BIRTHDAY: explorePlusModalTemplate?.dataset.levelBirthday || 'Birthday',
    };

    return levelTranslations[levelCode.toUpperCase()] || levelCode;
  };

  const generateCustomerWelcomeCoupon = async () => {
    try {
      const response = await fetch(appProxyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`API error: Cannot generate coupon`);
      }
    } catch (error) {
      console.error('Error generating customer welcome coupon:', error);
    }
  };

  const fetchCustomerCoupons = async () => {
    const couponsSection = document.querySelector('.explore-plus-coupons-section');
    if (!couponsSection) return;

    const loadingEl = couponsSection.querySelector('.explore-plus-coupons-loading');
    const errorEl = couponsSection.querySelector('.explore-plus-coupons-error');
    const tableWrapper = couponsSection.querySelector('.explore-plus-coupons-table-wrapper');
    const emptyEl = couponsSection.querySelector('.explore-plus-coupons-empty');
    const tbody = couponsSection.querySelector('.explore-plus-coupons-tbody');

    // Show loading state
    loadingEl.style.display = 'block';
    errorEl.style.display = 'none';
    tableWrapper.style.display = 'none';
    emptyEl.style.display = 'none';

    try {
      // Make API call to app proxy
      // The customer cookie will be automatically included in the request
      const response = await fetch(appProxyUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin', // Ensures cookies are sent
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const data = await response.json();

      // Hide loading
      loadingEl.style.display = 'none';

      const coupons = data.coupons || data || [];

      if (coupons.length === 0) {
        emptyEl.style.display = 'block';
        return;
      }

      // Clear existing rows
      tbody.innerHTML = '';

      // Get aria-label translations from template
      const copyAriaLabel = explorePlusModalTemplate?.dataset.copyAriaLabel || 'Copy code';
      const copiedAriaLabel = explorePlusModalTemplate?.dataset.copiedAriaLabel || 'Code is copied';

      // Set up copy handler
      tbody.onclick = (e) => {
        const btn = e.target.closest('.coupon-code-copy-btn');

        if (!btn) return;

        const code = btn.dataset.code;

        const onCopied = () => {
          btn.classList.add('copied');
          btn.setAttribute('aria-label', copiedAriaLabel);

          setTimeout(() => {
            btn.classList.remove('copied');
            btn.setAttribute('aria-label', copyAriaLabel);
          }, 2000);
        };

        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(onCopied);
        }
      };

      // Populate table with coupons
      coupons.forEach((coupon) => {
        const row = document.createElement('tr');
        const copyBtn = coupon.code
          ? `<button class="coupon-code-copy-btn" type="button" aria-label="${copyAriaLabel}">${copyIconSvg}${checkIconSvg}</button>`
          : '';
        row.innerHTML = `
          <td class="coupon-code">${escapeHtml(coupon.code || 'N/A')}${copyBtn}</td>
          <td>${escapeHtml(coupon.discountName || 'N/A')} - ${escapeHtml(translateLevel(coupon.level))}</td>
          <td>${escapeHtml(formatDate(coupon.expiresAt || 'N/A'))}</td>
        `;

        if (coupon.code) {
          row.querySelector('.coupon-code-copy-btn').dataset.code = coupon.code;
        }

        tbody.appendChild(row);
      });

      // Show table
      tableWrapper.style.display = 'block';
    } catch (error) {
      console.error('Error fetching coupons:', error);
      loadingEl.style.display = 'none';
      errorEl.style.display = 'block';
    }
  };

  // Helper function to attach event listener to modal action buttons
  const attachModalActionListener = (element) => {
    if (element.dataset.listenerAttached) return;

    element.addEventListener('click', (event) => {
      event.preventDefault();
      openExplorePlusModal();
    });

    element.dataset.listenerAttached = 'true';
  };

  // Attach listeners to any existing buttons
  explorePlusModalActions?.forEach((element) => {
    attachModalActionListener(element);
  });

  const buttonObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList?.contains('explore-plus-modal-action') && node.classList?.contains('open-modal')) {
              attachModalActionListener(node);
            }
            const buttons = node.querySelectorAll?.('.explore-plus-modal-action.open-modal');
            buttons?.forEach((button) => {
              attachModalActionListener(button);
            });
          }
        });
      }
    }
  });

  buttonObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  if (modalParam === 'true') {
    openExplorePlusModal();
    const url = new URL(window.location);
    url.searchParams.delete(modalParamName); // supprime le paramètre "token"
    window.history.replaceState({}, '', url);
  }

  // Check sessionStorage flag for post-login modal trigger
  if (sessionStorage.getItem('openExplorePlusModal') === 'true') {
    sessionStorage.removeItem('openExplorePlusModal');
    openExplorePlusModal();
  }

  // Listen for modal close events to reset coupons section
  formDialog?.addEventListener('close', () => {
    // Unlock body scroll when modal closes — restore normal scrolling behavior
    document.body.style.overflow = '';

    const couponsSection = document.querySelector('.explore-plus-coupons-section');

    if (couponsSection) {
      const loadingEl = couponsSection.querySelector('.explore-plus-coupons-loading');
      const errorEl = couponsSection.querySelector('.explore-plus-coupons-error');
      const tableWrapper = couponsSection.querySelector('.explore-plus-coupons-table-wrapper');
      const tbody = couponsSection.querySelector('.explore-plus-coupons-tbody');
      const emptyEl = couponsSection.querySelector('.explore-plus-coupons-empty');

      loadingEl.style.display = 'none';
      errorEl.style.display = 'none';
      tableWrapper.style.display = 'none';
      if (tbody) tbody.innerHTML = '';
      emptyEl.style.display = 'none';
    }
  });

  // Thank you message target element
  const targetElement = document.getElementById('formful-thanks-message');

  // Create a new MutationObserver instance to watch when thank you message is displayed
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const targetElement = mutation.target;

        handleMutation(targetElement);
      }
    }
  });

  const handleMutation = async (targetElement) => {
    const currentClasses = targetElement.classList;

    if (!currentClasses.contains('formful__hide') || currentClasses.contains('formful__show')) {
      await generateCustomerWelcomeCoupon();
      fetchCustomerCoupons();

      // Stop observing once the action is complete
      observer.disconnect();
    }
  };

  //Configure the observer to watch for 'class' attribute change
  const config = { attributes: true, attributeFilter: ['class'] };
  observer.observe(targetElement, config);
});
